(() => {
  const initFooterLanding = () => {
    const previousController = window.stimeezFooterLandingController;
    if (previousController) previousController.destroy();

    const root = document.querySelector('[data-footer-landing]');
    const panel = root?.querySelector('.b-stimeezFooterLanding');
    const footer = document.querySelector('.l-stimeezFooter');
    const footerSection = footer?.closest('.shopify-section');
    const shiftTarget = footerSection;
    if (!root || !panel || root.classList.contains('l-stimeezFooterLanding--editor')) return;
    shiftTarget?.classList.add('is-footer-landing-shift-target');

    const maxReveal = () => panel.offsetHeight;
    const pageEndScroll = () =>
      Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const endCaptureOffset = () => Math.min(160, Math.max(80, window.innerHeight * 0.12));
    const isPageEnd = () => window.scrollY >= pageEndScroll() - 2;
    const isNearPageEnd = () => window.scrollY >= pageEndScroll() - endCaptureOffset();

    let reveal = 0;
    let touchStartY = 0;
    let touchStartReveal = 0;
    let touchActive = false;
    let touchPulled = false;
    let sequenceTimer;
    let animationFrame;
    let isAnimating = false;
    let wheelSequenceActive = false;
    let wheelReleaseTimer;

    const revealDuration = 520;

    const isMobile = () => window.innerWidth <= 749;

    const applyReveal = (nextReveal) => {
      reveal = Math.max(0, Math.min(maxReveal(), nextReveal));
      const revealValue = `${Math.round(reveal)}px`;
      root.style.setProperty('--footer-landing-reveal', revealValue);
      shiftTarget?.style.setProperty('--footer-landing-reveal', revealValue);
    };

    const keepPageBottomPinned = () => {
      window.scrollTo(0, Math.max(0, document.documentElement.scrollHeight - window.innerHeight));
    };

    const snapToPageEnd = () => {
      window.scrollTo(0, pageEndScroll());
    };

    const setReveal = (nextReveal, pinBottom = false) => {
      applyReveal(nextReveal);
      if (pinBottom) keepPageBottomPinned();
    };

    const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);
    const easeInCubic = (progress) => progress * progress * progress;

    const animateReveal = (nextReveal, duration = revealDuration, pinBottom = true, easing = easeOutCubic) => {
      clearTimeout(sequenceTimer);
      cancelAnimationFrame(animationFrame);

      const startReveal = reveal;
      const finalReveal = Math.max(0, Math.min(maxReveal(), nextReveal));
      const distance = finalReveal - startReveal;
      const startTime = performance.now();

      return new Promise((resolve) => {
        const step = (currentTime) => {
          const progress = Math.min(1, (currentTime - startTime) / duration);
          setReveal(startReveal + distance * easing(progress), pinBottom);

          if (progress < 1) {
            animationFrame = requestAnimationFrame(step);
            return;
          }

          setReveal(finalReveal, pinBottom);
          resolve();
        };

        animationFrame = requestAnimationFrame(step);
      });
    };

    const updatePageEnd = () => {
      root.classList.toggle('is-page-end', isPageEnd());
    };

    const runSlingshot = async () => {
      if (isAnimating) return;
      isAnimating = true;
      touchActive = false;

      await animateReveal(maxReveal(), revealDuration, true, easeOutCubic);
      await animateReveal(0, revealDuration, true, easeInCubic);

      isAnimating = false;
    };

const scheduleWheelRelease = () => {
  clearTimeout(wheelReleaseTimer);

  wheelReleaseTimer = setTimeout(() => {
    if (isAnimating) {
      scheduleWheelRelease();
      return;
    }

    wheelSequenceActive = false;
  }, 300);
};

    const onWheel = (event) => {
  if (event.deltaY > 0 && isNearPageEnd()) {
    event.preventDefault();
    scheduleWheelRelease();

    if (wheelSequenceActive || isAnimating) return;

    wheelSequenceActive = true;
    snapToPageEnd();
    runSlingshot();
    return;
  }

  if (event.deltaY < 0 && reveal > 0) {
    event.preventDefault();
    setReveal(0, false);
  }
};

    const onTouchStart = (event) => {
      if (!isMobile() || isAnimating || !isNearPageEnd() || event.touches.length !== 1) return;
      snapToPageEnd();
      clearTimeout(sequenceTimer);
      cancelAnimationFrame(animationFrame);
      touchActive = true;
      touchPulled = false;
      touchStartY = event.touches[0].clientY;
      touchStartReveal = reveal;
    };

    const onTouchMove = (event) => {
      if (!touchActive || event.touches.length !== 1) return;
      const distance = touchStartY - event.touches[0].clientY;
      if (distance <= 0 && reveal <= 0) return;
      event.preventDefault();
      touchPulled = true;
      const nextReveal = touchStartReveal + distance * 1.2;
      setReveal(nextReveal, distance > 0);

      if (nextReveal >= maxReveal()) {
        runSlingshot();
      }
    };

    const onTouchEnd = () => {
      if (!touchActive) return;
      touchActive = false;
      if (touchPulled || reveal > 0) animateReveal(0, revealDuration, false, easeInCubic);
      touchPulled = false;
    };

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('scroll', updatePageEnd, { passive: true });
    window.addEventListener('resize', updatePageEnd);
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('touchcancel', onTouchEnd, { passive: true });
    updatePageEnd();

    window.stimeezFooterLandingController = {
      destroy() {
        clearTimeout(sequenceTimer);
        cancelAnimationFrame(animationFrame);
      
        shiftTarget?.style.removeProperty('--footer-landing-reveal');
        shiftTarget?.classList.remove('is-footer-landing-shift-target');
        window.removeEventListener('wheel', onWheel);
        window.removeEventListener('scroll', updatePageEnd);
        window.removeEventListener('resize', updatePageEnd);
        window.removeEventListener('touchstart', onTouchStart);
        window.removeEventListener('touchmove', onTouchMove);
        window.removeEventListener('touchend', onTouchEnd);
        window.removeEventListener('touchcancel', onTouchEnd);
      },
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLanding, { once: true });
  } else {
    initFooterLanding();
  }

  document.addEventListener('shopify:section:load', initFooterLanding);
})();
